export const weddingWebsitePageData = {
  seo: {
    title: 'Free Wedding Websites with Beautiful Templates & RSVP | Joy',
    content:
      'Create your unique wedding website in minutes for free with customizable templates. Includes online RSVP, guest list manager & matching invites.',
  },

  sections: {
    coloredBlock: {
      title: 'Still have questions?',
    },

    customizeTheme: {
      customizeText: 'Customize to your heart’s delight',
      unleashText: 'Unleash your inner creative or keep it simple with flexible design tools.',
      unleashTextMobile: 'Easily unleash your inner creative or keep it simple with flexible design tools.',
      highlights: [
        {
          title: 'Hand-crafted Designs',
          description:
            'Whether you’re going floral, modern, or feel undecided, browse hundreds of website design templates and customize them to match your style.',
          icon: 'designs',
        },
        {
          title: 'Your Color, Your Way',
          description:
            'Choose from any color, just as it should be. Follow the latest color trends or find that perfect peach-ish plum. Whatever hue tickles you pink, we have it.',
          icon: 'color',
        },
        {
          title: 'Get Fontastic',
          description: 'Find the perfect font — whether you know you need a serif or just that you want something elegant, we’ve got you. ',
          icon: 'font',
        },
        {
          title: 'Comfortable with code',
          description: 'Get under the hood and change the CSS to tweak the little details  —  we’re all about customization.',
          icon: 'code',
        },
      ],
    },

    cx: {
      title: 'And remember,<br/>we’re always here for you.',
      content:
        'Chat with the best customer service team in weddings —<br/>we’re here to make sure you get to the big day without the fray.',
      blocks: [
        {
          title: 'Jane Doe, Team Member since 2015',
          content: 'I get paid to help people in love — it doesn’t get better than that!',
        },
      ],
    },

    designs: {
      slideAltText: 'Wedding website design example',
      ctaText: 'Explore Design Templates',
      title: 'Hundreds of beautiful wedding website templates.',
      content: `Explore gorgeous website designs with matching prints or online wedding invitations. From classic to modern, find the design that fits your wedding style.`,
    },

    guestPhotos: {
      eyebrow: 'Unlimited Photo Storage',
      title: 'Before, during, forever after.',
      content: 'Experience your wedding day from every angle by allowing guests to upload photos to a shared photo gallery.',
    },

    heroVideo: {
      altText: 'Site template sample content',
      title: 'Your free wedding website and so much more.',
      content: 'Create a wedding website that is uniquely yours, completely customizable, and anticipates all your wedding planning needs.',
      getStarted: 'Get Started',
      findAnEvent: 'Find an Event',
      videoUrl: 'https://player.vimeo.com/video/652971545?h=87337e5435&badge=0&player_id=0&app_id=58479',
      videoPosterUrl: 'wedding-website/hero/ww_hero_static.jpg',
      videoTitle: 'Wedding Website Hero Video',
    },

    rsvpMadeEasy: {
      learnMoreCTAText: 'Learn More',
      title: 'RSVP on your site never felt so right.',
      content: 'Track who is coming to each wedding event, their meal choices, and more with powerful online RSVP.',
      getStartedCTAText: 'Learn about Smart RSVP',
      tabsData: [
        {
          title: 'Multiple Events',
          content: {
            title: 'Multiple Events',
            description: 'Add all of your gatherings to your schedule and keep your responses organized.',
            image: 'wedding-website/rsvp/multiple.svg',
          },
        },
        {
          title: 'Plus Ones and Households',
          content: {
            title: 'Plus Ones and Households',
            description: `Easily manage your guest list by limiting the number of plus ones per guest.`,
            image: 'wedding-website/rsvp/househould.svg',
          },
        },
        {
          title: 'Follow-up Questions',
          content: {
            title: 'Follow-up Questions',
            description: 'Get all the details by asking follow-up questions.',
            image: 'wedding-website/rsvp/followup.svg',
          },
        },
        {
          title: 'RSVP Tracking',
          content: {
            title: 'RSVP Tracking',
            description: 'Guest RSVPs automatically update in your guest list. Quickly see all your responses at a glance.',
            image: 'wedding-website/rsvp/tracking.svg',
          },
        },
      ],
    },

    siteToSee: {
      videoTitle: 'Site To See Video',
      videoUrl: 'https://player.vimeo.com/video/652971906?h=20ba5cec2a&badge=0&player_id=0&app_id=58479',
    },

    guestMobileApp: {
      videoTitle: 'Guest Mobile App Video',
      videoUrl: 'https://player.vimeo.com/video/472417945?h=8cb5d6b933&badge=0&player_id=0&app_id=58479',
      videoPosterUrl: 'app/couples-app/mobile-screen-schedule.jpg',
    },

    stats: {
      title: 'We’ve helped millions celebrate love around the world.',
      subtitle: 'That’s more cake, flowers and happy tears than we can count.',
    },

    travel: {
      columns: [
        {
          eyebrow: 'Guest Travel Tools',
          title: 'Don’t trip over travel.',
        },
        {
          eyebrow: 'Booking Assistant',
          title: 'Let attendees book accommodations from your site.',
          content: 'Help your guests easily find and book accommodations at the best rates through major travel sites.',
          contentMobile:
            'Help your guests book the right travel and accommodations with accurate and pre-filled destination, dates, and party number information.',
        },
        {
          eyebrow: 'Travel Recommendations',
          title: `Make sure guests' travel won’t unravel.`,
          titleMobile: 'Make sure no one’s travels unravel.',
          content:
            'From hotel blocks to airport details, transit schedules to shuttle info, share every little thing. Even list the best spots to grab a beer or burger.',
        },
        {
          eyebrow: 'Map and App Integrations',
          title: 'Map it all out for your guests.',
          content:
            'Allow your guests to easily get driving directions with Google Maps integrated into your schedule. They can even hail a ride with Uber and Lyft directly from your app.',
        },
      ],
    },

    underWraps: {
      header: {
        eyebrow: 'Powerful Event Privacy',
        title: 'Keep it under wraps.',
        content: 'Use your wedding guest list to manage who sees what on your site.',
        contentMobile: 'Customize who sees what to avoid hurt feelings and awkward conversations.',
      },
      details: {
        title: 'Personalized schedules for each of your guests',
        titleMobile: 'Schedules made specifically for each of your guests',
        content:
          'Rehearsal dinner? Secret post-wedding breakfast? Invite specific guests without having to explain to others why they didn’t get the memo.',
      },
      privateEventsAltText: 'Private Events',
      passwordProtectAltText: 'Password protect your events',
      options: {
        title: 'Password protect particular pages',
        content: 'Choose which pages are visible to everyone and which require your wedding password for access.',
      },
    },

    liveStream: {
      eyebrow: 'Virtual Weddings',
      title: 'Share the big moment together, even while apart.',
      content: `If extenuating circumstances prevent some guests from attending in-person, we've made it easy for you to host virtual wedding events right on your wedding website.`,
    },
    matchingStationery: {
      eyebrow: 'Matching Stationery',
      title: 'Save the Date and invites to match your site.',
      body:
        'Your wedding website comes with beautiful matching Save the Dates and invitations, available as eCards or prints, plus stationery for all your wedding day needs!',
      saveTheDateCta: 'Explore Save the Dates',
      invitationsCta: 'Explore Invitations',
    },
  },

  stats: [
    {
      title: 'million',
      body: 'The largest guest list in Joy',
      endingNumber: 8,
      incrementFrequency: 150,
    },
    {
      title: 'countries',
      body: 'Screaming babies have interrupted weddings on',
      endingNumber: 86,
      incrementFrequency: 100,
    },
    {
      title: 'guests',
      body: 'People around the world',
      endingNumber: 768,
      incrementFrequency: 20,
    },
  ],
  personalSaveTheDatesSectionData: {
    templateAltText1: 'Save the Date template',
    templateAltText2: 'Save the Date template 2',
    main: {
      eyebrow: 'Matching Save the Dates',
      title: 'Tailored to each guest you invite, just like your site.',
      content: '',
    },
    ctaText: 'Learn More',
  },
  connectedGuestList: {
    eyebrow: 'The Connected Guest List',
    title: 'Control who sees what with your guest list.',
    getStarted: 'Get Started',
    learnMore: 'Learn More',
  },
} as const;
